import { Component } from '@angular/core';

/**
 * Component intended to be used within the `<el-flip-card>` and `<el-reveal-card>` components.
 *
 * Use it as a container for the front card.
 */
@Component({
  selector: 'el-card-front',
  template: '<ng-content select="el-card"></ng-content>',
})
export class ElCardFrontComponent { }

/**
 * Component intended to be used within the `<el-flip-card>` and `<el-reveal-card>` components.
 *
 * Use it as a container for the back card.
 */
@Component({
  selector: 'el-card-back',
  template: '<ng-content select="el-card"></ng-content>',
})
export class ElCardBackComponent { }
